var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-info-card',{attrs:{"title":"Instagram"}},[_c('v-row',{attrs:{"dense":""}},_vm._l((6),function(n){return _c('v-col',{key:n,attrs:{"cols":"auto"}},[_c('base-img',{attrs:{"src":require(`@/assets/insta-${n}.jpg`),"color":"grey lighten-1","width":"96","tile":""}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }